class CardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.slider = null;
    this._arrowsInitialized = false;
  }

  connectedCallback() {
    if (this.swiper) return;

    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    this.init();
  }

  init() {
    this.destroy();
    this.initSwiper();
    this.initArrows();
  }
initSwiper() {
  this.swiper = new Swiper(this.slider, {
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
    direction: 'horizontal',
    observer: true,
    observeParents: true,

    pagination: {
      el: this.querySelector('.swiper-pagination'),
      clickable: true
    },

    on: {
      init: () => {
        this.updatePaginationGroups();
        this.loadCurrentSlideImage();
      },

      slideChange: () => {
        this.updatePaginationGroups();
        this.loadCurrentSlideImage();
      }
    }
  });

  // Force release any stuck drag state
  this.slider.addEventListener('mouseleave', () => {
    if (this.swiper) {
      this.swiper.allowClick = true;
    }
  });
}
  updatePaginationGroups() {
    if (!this.swiper) return;

    const bullets = this.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets.length) return;

    const groupSize = 3;
    const activeIndex = this.swiper.realIndex;

    const groupStart =
      Math.floor(activeIndex / groupSize) * groupSize;

    const groupEnd = groupStart + groupSize;

    bullets.forEach((bullet, index) => {
      bullet.style.display =
        index >= groupStart && index < groupEnd
          ? 'inline-block'
          : 'none';
    });
  }

  loadCurrentSlideImage() {
    if (!this.swiper) return;

    const currentSlide =
      this.swiper.slides[this.swiper.activeIndex];

    if (!currentSlide) return;

    const activeImage = currentSlide.querySelector('img');

    if (!activeImage) return;

    const dataSrc = activeImage.dataset.src;
    const dataSrcset = activeImage.dataset.srcset;

    if (dataSrc && activeImage.src !== dataSrc) {
      activeImage.src = dataSrc;
    }

    if (dataSrcset && activeImage.srcset !== dataSrcset) {
      activeImage.srcset = dataSrcset;
    }

    activeImage.classList.add('is-loaded');
  }

  applyFilter(color) {
    const allSlides = this.querySelectorAll('.swiper-slide-main');

    allSlides.forEach(slide => {
      const isMatch = slide.dataset.color === color;

      slide.style.display = isMatch ? '' : 'none';
    });

    // Rebuild swiper after filtering
    setTimeout(() => {
      this.rebuild();
    }, 0);
  }

  initArrows() {
    if (this._arrowsInitialized) return;

    this._arrowsInitialized = true;

    const prevBtn = this.querySelector('[prev]');
    const nextBtn = this.querySelector('[next]');

    prevBtn?.addEventListener('click', e => {
      e.preventDefault();

      if (this.swiper) {
        this.swiper.slidePrev();
      }
    });

    nextBtn?.addEventListener('click', e => {
      e.preventDefault();

      if (this.swiper) {
        this.swiper.slideNext();
      }
    });
  }

  rebuild() {
    this.destroy();

    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  destroy() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  disconnectedCallback() {
    this.destroy();
  }
}

customElements.define('card-product-slider', CardProductSlider);

class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    this.radios = this.querySelectorAll('input[type="radio"][data-variant-id]');
    this.radios.forEach(radio => {
      radio.addEventListener('change', this.onInputChange);
    });

    const anyRadio = this.radios[0];
    if (!anyRadio) return;

    const productId = anyRadio.getAttribute('data-product-id');
    const sectionId = anyRadio.getAttribute('data-section-id');

    const savedVariantId =
      sessionStorage.getItem(`selectedVariant-${sectionId}-${productId}`) ||
      sessionStorage.getItem(`selectedSwatch-${sectionId}-${productId}`);

    let radioToActivate = null;

    if (savedVariantId) {
      radioToActivate = this.querySelector(
        `input[type="radio"][data-variant-id="${savedVariantId}"]`
      );
    }

    if (!radioToActivate) {
      radioToActivate = this.querySelector(
        'input[type="radio"][data-variant-id]:checked'
      );
    }

    if (!radioToActivate) {
      radioToActivate = this.radios[0];
      radioToActivate.checked = true;
    }

    if (radioToActivate) {
      this.onInputChange({ target: radioToActivate });
    }
  }

  storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
  }

  storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
  }

  getProductImageData(productId) {
    const scriptTag = document.querySelector(`script[data-product-id="${productId}"]`);
    if (!scriptTag) return { variantDataMap: {}, colorImageMap: {} };

    const scriptContent = scriptTag.textContent;
    let variantDataMap = {};
    let colorImageMap = {};

    const variantMatch = scriptContent.match(/var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/);
    const colorMatch = scriptContent.match(/var\s+colorImageMap\s*=\s*(\{[\s\S]*?\});/);

    try {
      if (variantMatch) variantDataMap = JSON.parse(variantMatch[1]);
      if (colorMatch) colorImageMap = JSON.parse(colorMatch[1]);
    } catch (err) {
      console.error('Product image map parse error:', productId, err);
    }

    return { variantDataMap, colorImageMap };
  }

  getVariantImageUrl(productId, variantId, colorValue) {
    const { variantDataMap, colorImageMap } = this.getProductImageData(productId);
    const variantData = variantDataMap[variantId];

    if (variantData?.imageUrl) return variantData.imageUrl;
    if (colorValue && colorImageMap[colorValue]) return colorImageMap[colorValue];

    return null;
  }

  updateCardVariantImage(productGrid, productId, variantId, colorValue) {
    const cardImage = productGrid?.querySelector('[data-card-variant-image]');
    if (!cardImage) return;

    const imageUrl = this.getVariantImageUrl(productId, variantId, colorValue);
    if (!imageUrl || cardImage.src === imageUrl) return;

    cardImage.src = imageUrl;
    cardImage.removeAttribute('srcset');
    cardImage.dataset.originalSrc = imageUrl;
    cardImage.classList.add('is-loaded');
  }

  onInputChange(event) {
    const radio = event.target;

    const newVariantId = radio.getAttribute('data-variant-id');
    const newProductId = radio.getAttribute('data-product-id');
    const sectionId = radio.getAttribute('data-section-id');
    const selectedColor = radio.value;

    this.storeSelectedVariant(sectionId, newProductId, newVariantId);
    this.storeSelectedSwatch(sectionId, newProductId, newVariantId);

    const productGrid = radio.closest('[card-product-grid]');

    /* Previous slider-based color filter setup
    const sliderElement = productGrid?.querySelector('[card-product-slider]');

    if (sliderElement && selectedColor) {
      const allSlides = sliderElement.querySelectorAll('.swiper-slide-main');

      allSlides.forEach(slide => {
        const slideColor = slide.getAttribute('data-color');
        if (slideColor === selectedColor) {
          slide.style.display = '';
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
        } else {
          slide.style.display = 'none';
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
        }
      });

      const cardSlider = sliderElement.closest('card-product-slider');

      if (cardSlider && typeof cardSlider.rebuild === 'function') {
        cardSlider.rebuild();
      }
    }
    */

    if (productGrid) {
      this.updateCardVariantImage(productGrid, newProductId, newVariantId, selectedColor);

      const productForm = productGrid.querySelector('product-form');
      if (productForm) {
        const idElement = productForm.querySelector("[name='id']");
        if (idElement) idElement.value = newVariantId;
      }

      const { variantDataMap } = this.getProductImageData(newProductId);
      const productLinks = productGrid.querySelectorAll('.cs-card__image-link, .cs-card__title-link');
      if (variantDataMap[newVariantId]?.productUrl) {
        productLinks.forEach(link => {
          link.href = variantDataMap[newVariantId].productUrl;
        });
      }
    }
  }
}

customElements.define('custom-swatches', CustomSwatches);